<template>
  <div>
    <div class="white-bg padding-left padding-right padding-top border-radius-top">
      <div class="flex justify-between">
        <div class="text-title">
          {{ $t('productDetail.title') }}
        </div>
        <div></div>
      </div>

      <!-- 商品信息 -->
      <div class="margin-top">
        <div class="text-center vc-float-left" style="width: 150px;height: 140px;display: flex;align-items: center;justify-content: center;" v-if="productDetailInfo.coverPhoto">
          <el-image style="width: 120px;height: 140px;" class="border-radius" :src="productDetailInfo.coverPhoto" fit="cover" />
        </div>
        <div class="text-center vc-float-left" style="width: 150px;height: 140px;display: flex;align-items: center;justify-content: center;" v-else>
          <el-image style="width: 120px;height: 140px;" class="border-radius" src="/img/noPhoto.jpg" fit="cover" />
        </div>
        <el-form class="text-left">
          <el-row :gutter="20">
            <el-col :span="5">
              <el-form-item label="商品ID">
                <span>{{ productDetailInfo.productId }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="商品分组">
                <span>{{ productDetailInfo.categoryName || '-' }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="商品名称">
                <span>{{ productDetailInfo.prodName }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="仓库">
                <span>{{ productDetailInfo.shName || '-' }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="销量">
                <span>{{ productDetailInfo.sales || '-' }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="库存">
                <span>{{ productDetailInfo.stock || '-' }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="金额/积分">
                <span>{{ productDetailInfo.price || '-' }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="排序">
                <span>{{ productDetailInfo.sort || '-' }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="状态">
                <span>{{ productDetailInfo.stateName || '-' }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="创建时间">
                <span>{{ productDetailInfo.createTime || '-' }}</span>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>

      <div class="vc-line-primary margin-top"></div>

      <div class="margin-top-sm">
        <el-tabs v-model="productDetailInfo._currentTab" @tab-click="changeTab(productDetailInfo._currentTab)">
          <el-tab-pane label="商品规格" name="productDetailSpec"></el-tab-pane>
          <el-tab-pane label="商品评论" name="productDetailAppraise"></el-tab-pane>
          <el-tab-pane label="商品标签" name="productDetailLabel"></el-tab-pane>
          <el-tab-pane label="入库记录" name="productDetailInstock"></el-tab-pane>
          <el-tab-pane label="出库记录" name="productDetailOutstock"></el-tab-pane>
          <el-tab-pane label="盘点记录" name="productDetailInventory"></el-tab-pane>
          <el-tab-pane label="调拨记录" name="productDetailAllocation"></el-tab-pane>
          <el-tab-pane label="商品订单" name="productDetailCart"></el-tab-pane>
          <el-tab-pane label="商品退货" name="productDetailRefund"></el-tab-pane>
          <el-tab-pane label="商品拼团" name="productDetailGroup"></el-tab-pane>
          <el-tab-pane label="拼团订单" name="productDetailGroupOrder"></el-tab-pane>
          <el-tab-pane label="商品秒杀" name="productDetailSeckill"></el-tab-pane>
          <el-tab-pane label="秒杀订单" name="productDetailSeckillOrder"></el-tab-pane>
        </el-tabs>
      </div>
    </div>

    <div class="white-bg padding-left padding-right border-radius-bottom">
      <component :is="productDetailInfo._currentTab" :ref="productDetailInfo._currentTab"></component>
    </div>
  </div>
</template>

<script>
import { getShopId } from '@/api/shop/shopApi'
import productDetailSpec from '@/components/goods/productDetailSpec/productDetailSpec'
import productDetailAppraise from '@/components/goods/productDetailAppraise/productDetailAppraise'
import productDetailLabel from '@/components/goods/productDetailLabel/productDetailLabel'
import productDetailInstock from '@/components/goods/productDetailInstock/productDetailInstock'
import productDetailOutstock from '@/components/goods/productDetailOutstock/productDetailOutstock'
import productDetailInventory from '@/components/goods/productDetailInventory/productDetailInventory'
import productDetailAllocation from '@/components/goods/productDetailAllocation/productDetailAllocation'
import productDetailCart from '@/components/goods/productDetailCart/productDetailCart'
import productDetailRefund from '@/components/goods/productDetailRefund/productDetailRefund'
import productDetailGroup from '@/components/goods/productDetailGroup/productDetailGroup'
import productDetailGroupOrder from '@/components/goods/productDetailGroupOrder/productDetailGroupOrder'
import productDetailSeckill from '@/components/goods/productDetailSeckill/productDetailSeckill'
import productDetailSeckillOrder from '@/components/goods/productDetailSeckillOrder/productDetailSeckillOrder'
import { queryProduct } from '@/api/goods/productApi'

export default {
  name: 'ProductDetail',
  components: {
    productDetailSpec,
    productDetailAppraise,
    productDetailLabel,
    productDetailInstock,
    productDetailOutstock,
    productDetailInventory,
    productDetailAllocation,
    productDetailCart,
    productDetailRefund,
    productDetailGroup,
    productDetailGroupOrder,
    productDetailSeckill,
    productDetailSeckillOrder
  },
  data() {
    return {
      productDetailInfo: {
        productId: '',
        coverPhoto: '',
        categoryName: '',
        prodName: '',
        shName: '',
        sales: '',
        stock: '',
        price: '',
        sort: '',
        stateName: '',
        createTime: '',
        _currentTab: 'productDetailSpec'
      },
      shopId: ''
    }
  },
  created() {
    this.shopId = getShopId()
    this.productDetailInfo.productId = this.$route.query.productId
    if (!this.productDetailInfo.productId) {
      return
    }
    this.listProduct()
  },
  methods: {
    async listProduct() {
      const res = await queryProduct({
        page: 1,
        row: 1,
        productId: this.productDetailInfo.productId,
        shopId: this.shopId
      })
      Object.assign(this.productDetailInfo, res.data[0])
      this.changeTab(this.productDetailInfo._currentTab)
    },
    changeTab(tabName) {
      this.productDetailInfo._currentTab = tabName
      setTimeout(() => {
        this.$refs[tabName].open({
          productId: this.productDetailInfo.productId,
          prodName: this.productDetailInfo.prodName
        })
      }, 100)
    }
  }
}
</script>

<style scoped>
.white-bg {
  background-color: #fff;
}

.padding-left {
  padding-left: 20px;
}

.padding-right {
  padding-right: 20px;
}

.padding-top {
  padding-top: 20px;
}

.border-radius-top {
  border-radius: 4px 4px 0 0;
}

.border-radius-bottom {
  border-radius: 0 0 4px 4px;
}

.flex {
  display: flex;
}

.justify-between {
  justify-content: space-between;
}

.text-title {
  font-size: 18px;
  font-weight: bold;
}

.margin-top {
  margin-top: 20px;
}

.margin-top-sm {
  margin-top: 10px;
}

.vc-float-left {
  float: left;
}

.border-radius {
  border-radius: 4px;
}

.vc-line-primary {
  border-top: 1px solid #409EFF;
}
</style>